import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import layoutContext from "../../../context/LayoutContext";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Faq = () => {
  const layout = useContext(layoutContext);

  useEffect(() => {
    layout.setSmallNavText("Frequently Asked Questions");
  }, []);

  return (
    <StyledFaq>
      <Container>
        <UnderlinedHeader bolder text={"Często zadawane pytania"} />
        <UnderlinedHeader
          soft
          text={"CZY MOŻNA ZWRÓCIĆ POJEDYNCZE CZĘŚCI POCHODZĄCE Z ZESTAWU?"}
        />
        <p>
          Jeżeli części zostały zakupione jako zestaw, nie ma mozliwości zwrotu
          pojedynczych jego składowych. W takich przypadkach istnieje możliwość 
          zwrotu tylko całego zestawu zawierające wszystkie jego składowe. Zwroty 
          pojedynczych składowych zestawów będą odrzucane i odsyłane na koszt kupującego.
        </p>
        <UnderlinedHeader
          soft
          text={"JAK SPRAWDZIĆ, KIEDY PRODUKT BĘDZIE PONOWNIE DOSTĘPNY?"}
        />
        <p>
          Jeśli produkt jest wyświetlany jako „niedostępny”, możesz wysłać nam
          wiadomość, klikając zielony przycisk „wyślij zapytanie” na karcie
          produktu lub skontaktować się z nami za pośrednictwem formularza
          kontaktowego <Link to={"/contact"}>tutaj</Link>.
        </p>
        <UnderlinedHeader
          soft
          text={
            "JAK SPRAWDZIĆ, CZY DANA CZĘŚĆ BĘDZIE PASOWAĆ DO MOJEGO SAMOCHODU?"
          }
        />
        <p>
          Proszę kliknąć na "Pasuje do" pod zdjęciem produktu na karcie
          produktu. Pojawi się lista pojazdów.
        </p>
        <UnderlinedHeader
          soft
          text={"MOJEGO SAMOCHODU NIE MA W PASKU WYSZUKIWANIA, DLACZEGO?"}
        />
        <p>
          Twój samochód może być rzadkością na rynku europejskim. Możesz
          sprawdzić, czy produkt będzie pasował do Twojego samochodu,
          kontaktując się z nami <Link to={"/contact"}>tutaj</Link>.
        </p>
        <UnderlinedHeader
          soft
          text={
            "JAKIE SĄ WARUNKI WYSYŁKI PRODUKTÓW BĘDĄCYCH NA STANIE W MAGAZYNIE?"
          }
        />
        <p>
          Warunki wysyłki wraz z przewidywanym czasem dostawy można znaleźć{" "}
          <Link to={"/shipping"}>tutaj</Link>.
        </p>
        <UnderlinedHeader
          soft
          text={"JAKA JEST GWARANCJA NA PRODUKTY PEDDERS?"}
        />
        <p>
          Szczegółowe warunki gwarancji można znaleźć w naszym formularzu
          gwarancyjnym <Link to={"/warranties"}>tutaj</Link>.
        </p>
        <UnderlinedHeader
          soft
          text={"GDZIE MOGĘ ZGŁOSIĆ REKLAMACJĘ NA PRODUKTY PEDDERS?"}
        />
        <p>
          Reklamację możesz złożyć postępując zgodnie z instrukcjami na stronie
          Gwarancje{" "}
          <a
            href={"https://dba4x4.home.pl/warranty/PEDDERS/"}
            target={"_blank"}
            rel={"noopener noreferrer nofollow"}
          >
            tutaj
          </a>
          .
        </p>
      </Container>
    </StyledFaq>
  );
};

export default Faq;

const StyledFaq = styled.section`
  padding-top: 30px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #666666;
  text-align: justify;
  line-height: 1.66;
`;
